import request from '@/router/axios';
export const update = (row) => {
    return request({
        url: '/api/produce/truck-transport-plan/update',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/truck-transport-plan/getById',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (data) => {
    return request({
        url: '/api/produce/truck-transport-plan/intelligent-plan/selectPage',
        method: 'post',
        data
    })
}
export const exportExcel = (data) => {
    return request({
        url: '/api/produce/truck-transport-plan/intelligent-plan/export',
        method: 'post',
        data,
        responseType: 'blob'
    })
}
export const remove = (id) => {
    return request({
        url: '/api/produce/truck-transport-plan/delete',
        method: 'post',
        data: {
            id
        }
    })
}

